import { ReactNode } from 'react';

import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';
import useResidentSettingsState from 'features/residents/resident-settings/providers/states/resident-settings-state';

type Props = {
  children: ReactNode;
};

const ResidentSettingsProvider = ({ children }: Props): React.JSX.Element => (
  <ResidentSettingsProviderContext value={useResidentSettingsState()}>{children}</ResidentSettingsProviderContext>
);

export default ResidentSettingsProvider;
